import {
  TweenMax,
  TimelineMax,
  TimelineLite,
  Sine,
  Linear
} from "gsap";
import { Tween } from "jquery";
// Power2, Elastic, CSSPlugin ,Tweenmax
export function play() {

  TweenMax.to(`[data-name="people_dog"]`, 3, {
    y: -40,
    x: 30,
    rotate: -5,
    ease: Sine.easeInOut,
  }).repeat(-1).yoyo(true)
  TweenMax.to(`[data-name="people_woman"]`, 10, {
    y: -10,
    x: 10,
    ease: Sine.easeInOut,
  }).repeat(-1).yoyo(true)

  TweenMax.to(`[data-name="taipeipass"]`, 2, {
    y: -20,
    // x: 10,
    ease: Sine.easeInOut,
  }).repeat(-1).yoyo(true)


  // face ID face
  let face = `[data-name="face"]`
  TweenMax.set(face , {
    transformOrigin: "50% 50% 0%",
    rotate: -2,
  })
  TweenMax.to(face, 1, {
    rotate: 2,
    scale: 1.1
  }).repeat(-1).yoyo(true)

  let focusArea = `[data-name="focus_area"]`
  TweenMax.set(focusArea , {
    transformOrigin: "50% 50% 0%",
  })
  TweenMax.to(focusArea, 1, {
    scale: 1.2
  }).repeat(-1).yoyo(true)

  let tl = new TimelineMax();
  tl.to("[data-name='coin']", 0.5, {
    y: -50,
    ease: Sine.easeInOut
  }).to("[data-name='coin']", 1, {
    y: -100,
    opacity: 0,
  }).repeat(-1)


  let tl2 = new TimelineMax();
  tl2.to("[data-name='other_taipeipass']", 2.5, {
    x: -10,
    y: -10,
    ease: Sine.easeInOut
  }).to("[data-name='other_taipeipass']", 3, {
    x: 10,
    y: 10,
    ease: Sine.easeInOut
  }).repeat(-1).yoyo(true)

  let cards = `[data-name='cards'] > g`

  function addShowCardAni(tl,query){
    return tl.to(query,0.35,{
      opacity: 1
    }).to(query,0.35,{
      opacity: 0,
      delay: 2.5
    })
  }
  let tlcq = new TimelineMax()
  tlcq.set(cards, {
    css:{
      "opacity": 0,
      "mix-blend-mode": "multiply",
    }
  })
  for(var i=1;i<4;i++){
    addShowCardAni(tlcq,`${cards}:nth-child(${i})`)
  }

  tlcq.repeat(-1)
  tlcq.play()
}